import { get , post } from "./fetch";

/**
 * @param {Object} data
 * @param {number} data.subscriptionID
 * @param {bool} data.cancelNow
 * @param {bool} data.cancelAllPlanPayments
 */
 export const cancelSubscription = (data) => {
    return post(`/api/manager/subscription/cancel`, data);
}

/**
 * @param {number} subscriptionID
 */
 export const endTrial = (subscriptionID) => {
    return post(`/api/manager/subscription/${subscriptionID}/trial/end`);
}

/**
 * @param {Object} data
 * @param {number} data.commissionPaymentID
 */
 export const cancelCommissionPayment = (data) => {
    return post(`/api/manager/commission/payment/cancel`, data);
}

/**
 * @param {Object} data
 * @param {number} data.planPaymentID
 */
 export const getCommissionPaymentFromRequestID = (requestID) => {
    return get(`/api/manager/commission/payment/request/${requestID}`);
}

/**
 * @param {Object} data
 * @param {number} data.commissionPaymentID
 * @param {number} data.amount
 */
 export const refundCommissionPayment = (data) => {
    return post(`/api/manager/commission/payment/refund`, data);
}
